<template>
  <div class="hb-bab-datelocation px-6" v-if="showDateLocation">
    <div class="d-flex mt-2 mb-6">
      <v-btn @click="dialog = true" text class="float-right text-uppercase primary--text pl-0">
        <v-icon>mdi-truck-delivery-outline</v-icon>
        check delivery coverage
      </v-btn>
    </div>

    <div id="location-picker" class="location">
      <h1 class="hb-title mb-2">SELECT YOUR LOCATION</h1>
      <div class="options-input-wrapper location mb-3">
          <input
            id="kl"
            type="radio"
            value="same_day"
            v-model="location"
            @input="updateAddons"
            hidden
          />

          <label style="font-weight:normal" class="cursor-pointer 
            location-options
            location
            kl-pj-klang-valley
            available
            px-3 py-2"
            :class="{'active': location == 'same_day'}"
            for="kl">
            KL, PJ &amp; Klang Valley
          </label>

          <!-- <input
            id="nationwide"
            type="radio"
            value="nationwide"
            v-model="location"
            @input="updateAddons"
            hidden
          />

          <label style="font-weight:normal" class="cursor-pointer 
            location-options
            location
            kl-pj-klang-valley
            available
            px-3 py-2"
            :class="{'active': location == 'nationwide'}"
            for="nationwide"> Nationwide </label> -->
      </div>
    </div>

    <hb-datepicker @input="updateAddons()"></hb-datepicker>

    <v-dialog v-model="dialog" width="500">
      <v-card class="pb-4 px-5 pt-2">
        <v-btn @click="dialog = false" class="float-right mr-n2" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="subtitle-1 mt-12">
          Please enter the recipient postcode to check the delivery coverage
        </div>

        <label for="postcode" class="mt-5">Postcode*</label>
        <v-text-field
          id="postcode"
          placeholder="e.g.: 50500"
          outlined
          :hint="hint"
          persistent-hint
          v-model="postcode"
        ></v-text-field>

        <button @click="setLocation('same_day')" v-if="isCovered === 'sameday' && postcode.length === 5" style="width: 100%" class="btn-primary white--text mt-8 mb-5">
          Proceed with kl, pj & klang Valley
        </button>
        <button @click="setLocation('nationwide')" v-else-if="isCovered !== 'sameday' && postcode.length === 5" style="width: 100%; background: white" class="btn-primary primary--text mt-8 mb-5">
          I WOULD TO PROCEED WITH NATIONWIDE
        </button>
        <button @click="dialog = false" v-else style="width: 100%; background: white" class="btn-primary primary--text mt-8 mb-5">
          CANCEL
        </button>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TYPE_SET_ADDONS, TYPE_SET_CATEGORIES, TYPE_SET_DELIVERY_AREA, TYPE_SET_GIFTS, TYPE_SET_TIMESLOTS } from '../../store/mutations';
import hbDatepicker from './DatePicker.vue'
import zipChecker from '../../../common/zipChecker';
import moment from 'moment';
import { getBabAddons, getBabTypes, getGifts } from '../../api/products';
import { ACTION_GET_DATA } from '../../store/actions';
import {getTimeSlots} from '../../../common/api/static'

export default {
  name: "hb-bab-datelocation",
  components:{
    hbDatepicker
  },
  data() {
    return {
      dialog: false,
      postcode: '',
    };
  },
  methods:{
    setLocation(location){
      this.location = location;
      this.dialog = false;
    },
    async updateAddons(e){
      try{
        const date = this.$store.state.delivery.delivery_date;
        const location = e? e.target.value:this.location;

        if(date){
          this.$store.dispatch(ACTION_GET_DATA,{date,location})
          this.$store.commit(TYPE_SET_TIMESLOTS, await getTimeSlots({
            time_slot_name: 'mothers_day',
            auto_swap: 'true',
            delivery_date: date
          }));
        }
      }
      catch(e){
        alert(e)
      }
    }
  },
  computed:{
    showDateLocation(){
      return this.$store.state.step === 1 && this.$store.state.substep === 1;
    },
    isCovered(){
      return zipChecker(this.postcode);
    },
    hint(){
      if(this.postcode.length !== 5) return;
      // if(this.isCovered == 'sameday' && !this.isSameDayAvailable || this.isCovered== 'nationwide' && !this.isNationwideAvailable){
      //   return 'This area is not in our delivery coverage';
      // }
      return this.isCovered == 'sameday'? 'This area is covered in Klang Valley' : 'This area is not covered within Klang Valley area';
    },
    location:{
      get(){
        return this.$store.state.deliveryArea;
      },
      set(value){
        this.$store.commit(TYPE_SET_DELIVERY_AREA, value);
      }
    },
    product(){
      return this.$store.state.productDetails
    },
    isSameDayAvailable(){
      return this.product?.available_dates?.same_day?.available_date_range?.start_date !== null
    },
    isNationwideAvailable(){
      return this.product?.available_dates?.nationwide?.available_date_range?.start_date !== null
    }
  }
};
</script>

<style>
</style>